import { useMemo } from 'react'
import { useAppSelector } from '@store/hooks'
import { Patient } from '@dataTypes/PatientInfo.types'
import { Provider } from '@dataTypes/provider.types'
import { useClinicProviders } from './useClinicProviders'

/** Patients configured for the practice, falling back to the currently selected patient(s). */
export const usePracticePatients = (): Patient[] => {
  const patients = useAppSelector((state) => state.patient.data)
  const selectedPatient = useAppSelector(
    (state) => state.patient.selectedPatient,
  )
  const selectedPatients = useAppSelector(
    (state) => state.patient.selectedPatients,
  )

  return useMemo(() => {
    if (patients.length > 0) return patients
    const list = [...selectedPatients]
    if (
      selectedPatient &&
      !list.some((patient) => patient.patient_id === selectedPatient.patient_id)
    ) {
      list.unshift(selectedPatient)
    }
    return list
  }, [patients, selectedPatient, selectedPatients])
}

/** Providers for the selected clinic. */
export const usePracticeProviderList = (): Provider[] => {
  useClinicProviders()
  const providers = useAppSelector((state) => state.provider.data)
  return useMemo(
    () => providers.filter((provider) => !provider.is_hidden),
    [providers],
  )
}
